// lib/account-hub-reopen.ts
//
// "Reopen the profile panel after navigating back from a full-page account
// route" signal. Relocated verbatim (2026-07-23, OVERLAY_FSM_SPEC §E step
// 1.1) out of the now-deleted `hooks/use-profile-tab-state.ts` — it is a
// navigation-intent flag, not overlay-panel state, so it doesn't belong in
// `lib/overlay/overlay-state.ts`'s FSM. Kept as a plain module-level flag
// (no React).
//
// Flow: a full-page `/account` route (mobile-only) calls
// `requestAccountHubReopen()` right before navigating back to `/feed`;
// `bottom-nav-bar-client.tsx` calls `consumeAccountHubReopen()` on mount/
// pathname-change and, if true, opens the profile panel
// (`openPanel({ kind: "profile" })`).

let reopenAfterNavigation = false;

export function requestAccountHubReopen() {
  reopenAfterNavigation = true;
}

export function consumeAccountHubReopen(): boolean {
  if (!reopenAfterNavigation) return false;
  reopenAfterNavigation = false;
  return true;
}
